import apiServices from "../apiServices";
import { validateOrThrowApiResponse } from "../response-validator";

type UploadMediaFormData = {
    file: File | Blob;
    fileName?: string;
    sectionName?: string;
    user_uuid?: string;
    ref_id?: string;
};

const uploadAPI = {

    uploadMedia(payload: UploadMediaFormData) {
        const formData = new FormData();
        if (payload.fileName) {
            formData.append("file", payload.file, payload.fileName);
        } else {
            formData.append("file", payload.file);
        }
        if (payload.sectionName) formData.append("sectionName", payload.sectionName);
        if (payload.user_uuid) formData.append("user_uuid", payload.user_uuid);
        if (payload.ref_id) formData.append("ref_id", payload.ref_id);

        return apiServices
            .post(`/api/upload-media`, formData, {
                headers: {
                    Accept: "application/json",
                },
            })
            .then((res) => validateOrThrowApiResponse(res))
            .catch((err) => {
                console.log("Error uploadMedia:", err);
                return {
                    status: "failed",
                    errMessage: err?.message || err,
                    error: err,
                };
            });
    },

}

export default uploadAPI;